// extracted by mini-css-extract-plugin
module.exports = {"DrawerPaper":"Sidebar_DrawerPaper__K8Fiw","isPermanent":"Sidebar_isPermanent__1Qdu_"};